import { motion } from "framer-motion";

export const ease = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 48, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y, scale: 0.97 }}
    whileInView={{ opacity: 1, y: 0, scale: 1 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease, delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <span className={`inline-flex items-center gap-3 text-xs font-semibold tracking-[0.2em] uppercase text-[#2c5233] ${className}`}>
    <span className="h-px w-8 bg-[#d3a53a]" />
    {children}
  </span>
);
